import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { Row, Col, Form, Input, Modal } from 'antd';
import { Main, BasicFormWrapper } from '../../styled';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { AddUser } from '../style';
import HttpStatus from '../../../utility/status.enum';
import Spinner from '../../common/Spinner.js';
import phoneformat from '../../../utility/phoneFormat';
import { useDispatch } from 'react-redux';
import { getProfileV1 } from '../../../redux/userProfile/actionCreator';
import UpdateManageProfile from './UpdateManageProfile.js';
import { Button } from '../../../components/buttons/buttons.js';
import { useParams } from 'react-router-dom';
import Changepassword from '../changePassword/ChangePassword.js';
import { changePassword } from '../../../redux/manageHost/actionCreator.js';
import Notification from '../../../utility/notification.js';
import { useNavigate } from 'react-router-dom';
import { fetchCmsContent } from '../../../redux/manageCms/actionCreator.js';

const Profile = forwardRef((props, ref) => {
  const hostSlug = useParams()?.hostSlug ?? '';
  const { backEndPrefix, unsaveMessage, passwordPattern } = global;
  const dispatch = useDispatch();
  const updateProfileRef = useRef(null);
  const [form] = Form.useForm();
  const [hostDetail, setHostDetail] = useState([]);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [isDetails, setIsDetails] = useState(true);
  const [changepasswordModal, setChangepasswordModal] = useState(false);
  const [isChangePasswordDirty, setChangePasswordDirty] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [adminPasswordChangeShow, setAdminPasswordChangeShow] = useState(false);
  const [cmsPopupShow, setCmsPopupShow] = useState(false);
  const [cmsMessageEmailHost, setCmsMessageEmailHost] = useState('');
  const navigate = useNavigate();

  // Expose functions to parent
  useImperativeHandle(ref, () => ({
    updateIsDetails: () => {
      if (!isDetails) {
        if (updateProfileRef.current) {
          updateProfileRef.current.submitForm();
        }
      }
      setIsDetails(false); // parent can call this
    },
    // You can expose more functions if needed
  }));

  // ✅ Function you want to run from child
  const handleAfterProfileUpdate = (isUpdate = false) => {
    if(isUpdate){
      getProfileFunction();
    }
    setIsDetails(true);
    // You can refresh tabs, update state, reload data, etc.
  };

  useEffect(() => {
    getProfileFunction();
  }, [hostSlug]);

  const getProfileFunction = async () => {
    try {
      setSpinnerLoader(true);
      const parms = hostSlug ? '?host_slug=' + hostSlug : '';
      const profileResponse = await dispatch(
        getProfileV1(parms, (response) => {
          return response;
        }),
      );
      if (profileResponse?.status !== HttpStatus.HTTP_OK) {
        // Show Error Alert
        setSpinnerLoader(false);
        navigate('/');
      } else {
        setHostDetail(profileResponse?.result);
        // update the global variable
        global.updatedLoginProfile = profileResponse?.result?.image;
        // If isShowCardsOnFile is undefined then only take already set isShowCardsOnFile as host login we don't pass this key
        global.isShowCardsOnFile = profileResponse?.result?.is_allowed_card_file ?? global.isShowCardsOnFile;
        global.isScheduledEnabled = profileResponse?.result?.is_scheduler_enable === 1;
        setSpinnerLoader(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleProfileUpdate = () => {
    setIsDetails(false);
  };

  const hidechangepasswordModal = () => {
    if (isChangePasswordDirty) {
      const confirmCancel = window.confirm(unsaveMessage);
      if (confirmCancel) {
        setChangePasswordDirty(false);
        setChangepasswordModal(false);
      }
    } else {
      setChangepasswordModal(false);
    }
  };

  const handleChangePasswordInputChange = () => {
    setChangePasswordDirty(true);
  };

  const handlechangepasswordModal = (e) => {
    e.preventDefault();
    // below permission is used for admin only
    if (global.checkPermission('host-change-password')) {
      setAdminPasswordChangeShow(true);
    } else {
      // For host login
      setChangepasswordModal(true);
    }
  };

  const handleChangePasswordClose = () => {
    if (isDirty) {
      const confirmCancel = window.confirm(unsaveMessage);
      if (!confirmCancel) return;
      setIsDirty(false);
      global.isDirtyGlobal = false;
    }
    form.resetFields(['confirm_password', 'new_password']);
    setAdminPasswordChangeShow(false);
  };

  const handleInputChange = () => {
    setIsDirty(true);
  };

  const changePasswordSave = (values) => {
    if (hostSlug) {
      setSpinnerLoader(true);
      const slug = hostSlug;
      const is_admin_request = 1;
      const requestData = { ...values, slug, is_admin_request };
      const savePassword = async () => {
        try {
          const passwordResponse = await dispatch(
            changePassword(requestData, (response) => {
              return response;
            }),
          );
          if (passwordResponse?.status !== HttpStatus.HTTP_OK) {
            Notification.addNotificationError(passwordResponse.message);
          } else {
            global.isDirtyGlobal = false;
            Notification.addNotificationSuccess(passwordResponse.message);
            setAdminPasswordChangeShow(false);
          }
          setSpinnerLoader(false);
        } catch (error) {}
      };
      savePassword();
    }
  };

  const fetchCmsContentData = async () => {
    setSpinnerLoader(true);
    try {
      const fetchCmsContentResponse = await dispatch(fetchCmsContent({ action_type: 18 }));
      if (fetchCmsContentResponse.status === HttpStatus.HTTP_OK) {
        const resultData = fetchCmsContentResponse?.result?.description;
        setCmsMessageEmailHost(resultData);
        setCmsPopupShow(true);
      }
    } catch (err) {
      console.error('Error in fetch CMS: ', err);
    } finally {
      setSpinnerLoader(false);
    }
  };

  const closePopupInfo = () => {
    setCmsPopupShow(false);
  }

  return (
    <>
      {isDetails ? (
        <Cards xs={24} headless className="borderRadius common_fiter_table">
          <Main className="mainBlock">
            <AddUser>
              <BasicFormWrapper>
                <Form form={form} name="contact">
                  <div headless className="host_userdetails_card">
                    <Spinner loader={spinnerLoader} />
                    <Row gutter={15}>
                      <Col xs={24} md={6}>
                        <div className="project-modal">
                          <div className="info">
                            <h4 className="ninjadash-ticket-details__top-title image_label">The avatar my guest see</h4>
                          </div>
                          <div className="">
                            <div className="upload-section">
                              <div className="ninjadash-ticket-date-info__text custom_ticket-date-info__text">
                                <span>
                                  <figure className="photo-upload align-center-v details_photo_upload">
                                    {hostDetail?.image ? (
                                      <a
                                        className="listing_details_photo_anchor"
                                        href={hostDetail?.image}
                                        target="__blank"
                                      >
                                        <img
                                          className={hostDetail ? 'image_uploaded' : ''}
                                          src={hostDetail?.image}
                                          alt="Listing"
                                        />
                                      </a>
                                    ) : (
                                      ' '
                                    )}
                                  </figure>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row gutter={15}>
                      <Col xs={24} md={12} className="d-flex align-items-center ">
                        <div className="project-modal">
                          <div className="ninjadash-ticket-date-info__text">
                            <h4 className="ninjadash-ticket-details__top-title">What my guests see under my avatar </h4>
                            <span>{hostDetail?.display_name || ''}</span>
                          </div>
                        </div>
                      </Col>

                      <Col xs={24} md={12} className="d-flex align-items-center ">
                        <div className="project-modal">
                          <div className="ninjadash-ticket-date-info__text">
                            <h4 className="ninjadash-ticket-details__top-title">
                              My management company's legal name for my rental agreements
                            </h4>
                            <span>{hostDetail?.company_name || ''}</span>
                          </div>
                        </div>
                      </Col>
                       <Col xs={24} md={12} className="d-flex align-items-center ">
                        <div className="project-modal">
                          <div className="ninjadash-ticket-date-info__text">
                            <h4 className="ninjadash-ticket-details__top-title">
                              The name auto-signing for my management company in my rental agreement
                            </h4>
                            <span>{hostDetail?.name || ''}</span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} md={12}>
                        <div className="project-modal">
                          <div className="ninjadash-ticket-date-info__text">
                            <h4 className="ninjadash-ticket-details__top-title">
                              My primary phone number on file in case Happy Guest needs to contact me directly
                            </h4>
                            <span>
                              {hostDetail?.phone_number ? phoneformat.formatPhoneNumber(hostDetail.phone_number) : ''}
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row gutter={15}>
                      <Col xs={24} md={12}>
                        <div className="project-modal">
                          <div className="ninjadash-ticket-date-info__text">
                            <h4 className="ninjadash-ticket-details__top-title">
                              The email I use to log in and receive notifications {/* Need to add CMS */}
                              {/* <a class="common_urlLink" onClick={() => fetchCmsContentData()}>
                                (Learn: How it works)
                              </a> */}
                            </h4>
                            <span>{hostDetail?.email || ''}</span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row gutter={15}>
                      <Col xs={24} md={12}>
                        <div className="project-modal">
                          <div className="ninjadash-ticket-date-info__text">
                            <h4 className="ninjadash-ticket-details__top-title">
                              The name used when I send an email to the guest
                            </h4>
                            <span>{hostDetail?.reply_name_for_email || ''}</span>
                          </div>
                        </div>
                      </Col>
                      <Col xs={24} md={12}>
                        <div className="project-modal">
                          <div className="ninjadash-ticket-date-info__text">
                            <h4 className="ninjadash-ticket-details__top-title">
                              The email used when the guest sends a reply
                            </h4>
                            <span>{hostDetail?.reply_email || ''}</span>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  {/* <div className="manage-listing-btn"> */}
                  {/* <Col xs={3}> */}
                  {/* <Button
                        htmlType="submit"
                        size="default"
                        shape="circle"
                        type="dark"
                        key="submit"
                        className="w-100 edit-btn"
                        onClick={handleProfileUpdate}
                      >
                        Edit
                      </Button> */}
                  {/* </Col> */}
                  {/* </div> */}
                  <Row gutter={15} className="mt-20">
                    <Col xs={6}>
                      <a class="common_urlLink" onClick={handlechangepasswordModal}>
                        Change Password
                      </a>
                    </Col>
                  </Row>
                </Form>
              </BasicFormWrapper>
            </AddUser>
          </Main>
        </Cards>
      ) : (
        // <AddUser>
        //   <BasicFormWrapper>
        <UpdateManageProfile ref={updateProfileRef} onProfileUpdated={handleAfterProfileUpdate}></UpdateManageProfile>
        //   </BasicFormWrapper>
        // </AddUser>
      )}
      <Changepassword
        changepasswordModal={changepasswordModal}
        hidechangepasswordModal={hidechangepasswordModal}
        handleChangePasswordInputChange={handleChangePasswordInputChange}
      />

      <Modal
        open={adminPasswordChangeShow}
        title="Change Password"
        footer={null}
        onCancel={handleChangePasswordClose}
        className="modal-md"
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="project-modal">
          <AddUser>
            <BasicFormWrapper>
              <Form form={form} name="changePassword" onFinish={changePasswordSave} onValuesChange={handleInputChange}>
                <Row gutter={15}>
                  <Col xs={24} md={24}>
                    <div className="project-modal">
                      <Form.Item
                        label="New Password"
                        name="new_password"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter new password',
                          },
                          {
                            min: 8,
                            message: 'Password must be at least 8 characters long',
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || value.length < 8) {
                                return Promise.resolve();
                              }
                              const pattern = new RegExp(passwordPattern);
                              if (pattern.test(value)) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error('Password must include uppercase, lowercase, number, and special character'),
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password placeholder="Enter new password" tabIndex="1" autoComplete="new_password" />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col xs={24} md={24}>
                    <div className="project-modal">
                      <Form.Item
                        name="confirm_password"
                        label="Confirm New Password"
                        dependencies={['new_password']}
                        rules={[
                          { required: true, message: 'Please enter confirm new password' },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value || getFieldValue('new_password') === value) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error('The new password and confirmation new password do not match'),
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          placeholder="Enter confirm new password"
                          tabIndex="2"
                          autoComplete="confirm_password"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24}>
                    <Button htmlType="submit" size="default" type="dark" shape="circle" key="submit" className="w-100">
                      {spinnerLoader ? 'Loading...' : 'Save'}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </BasicFormWrapper>
          </AddUser>
        </div>
      </Modal>
      <div className="manage-listing-btn">
        {isDetails && (
          <Button
            htmlType="submit"
            outlined
            shape="circle"
            type="primary"
            key="3"
            className="w-100 edit-btn"
            onClick={handleProfileUpdate}
          >
            Edit
          </Button>
        )}
      </div>
      <Modal
        open={cmsPopupShow}
        footer={null}
        onCancel={closePopupInfo}
        className="modal-md"
        key={2}
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="Idmodalbox earlyCheckinPopup">
          <div className="hostPayout">
            <div className="modal-content" dangerouslySetInnerHTML={{ __html: cmsMessageEmailHost }} />
          </div>
        </div>
      </Modal>
    </>
  );
});

export default Profile;
